import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { ThemeProvider } from "styled-components";
import { getToken } from "../services/auth";
import { GlobalStyle } from "../shared/GlobalStyles";
import { darkTheme } from "../shared/GlobalStyles/theme/darkTheme";
import { lightTheme } from "../shared/GlobalStyles/theme/lightTheme";


export const DarkModeContext = createContext([])

export const useDarkMode = () => useContext(DarkModeContext);

// Cores padrão para restaurar o tema vermelho
const defaultOverrides = {
    backgrounds: {
        red2: '#C51F2A',
        blue4: '#03134F',
    },
    colors: {
        red2: '#C51F2A',
    },
    border: {
        small_red2: '1.5px solid #C51F2A',
        very_small_red2: '1px solid #C51F2A',
    },
};
  
// Função para aplicar azul ou vermelho dinamicamente
const applyColorScheme = (theme, useBlue) => {
    if (useBlue) {
      theme.backgrounds.blue4 = theme.backgrounds.blue2;
      theme.backgrounds.red2 = theme.backgrounds.blue;
      theme.colors.red2 = theme.colors.blue;
      theme.border.small_red2 = theme.border.small_blue;
      theme.border.very_small_red2 = theme.border.very_small_blue;
    } else {
      theme.backgrounds.red2 =  defaultOverrides.backgrounds.red2;
      theme.backgrounds.blue4 = defaultOverrides.backgrounds.blue4;
      theme.colors.red2 = defaultOverrides.colors.red2;
      theme.border.small_red2 = defaultOverrides.border.small_red2;
      theme.border.very_small_red2 = defaultOverrides.border.very_small_red2;
    }

    return theme
};

export const DarkModeProvider = ({children}) => {
    const [darkModeButton, setDarkModeButton] = useState(() => {
        const stored = localStorage.getItem('APP_THEME_MODE');
        return stored ? JSON.parse(stored) : false;
    });
    const [isBlueMode, setIsBlueMode] = useState(() => {
        const token = getToken('SISTESHOP');
        return !!JSON.parse(token);
    });

    const verifySisteShop = () => {
        const token = getToken('SISTESHOP');
        const base = darkModeButton ? darkTheme : lightTheme;
        const theme = applyColorScheme(base, isBlueMode, darkModeButton);

        if(!!JSON.parse(token) && darkModeButton) return '#5992fd';
        if(!!JSON.parse(token)  && !darkModeButton) return theme.backgrounds.red2;
        if(!!!JSON.parse(token) && (darkModeButton || !darkModeButton)) return theme.backgrounds.red2;
        
    }

    const verifySisteShopIcon = () => {
        const token = getToken('SISTESHOP');
        if(!!JSON.parse(token)) return '#5992fd';
        return 'white'
    }

    
    const updateMode = useCallback(() => {
        setDarkModeButton(prev => {
            localStorage.setItem('APP_THEME_MODE', JSON.stringify(!prev));
            return !prev;
          });
    }, [darkModeButton])


    const selectedTheme = useMemo(() => {
        const base = darkModeButton ? darkTheme : lightTheme;
        const theme = { ...base }; // shallow copy
      
        applyColorScheme(theme, isBlueMode, darkModeButton);
        return theme;
    }, [darkModeButton, isBlueMode]);
    
    const contextValue = useMemo(() => ({
        darkModeButton,
        updateMode,
        selectedTheme,
        verifySisteShop,
        verifySisteShopIcon,
        updateSystemColor: (isBlue) => setIsBlueMode(isBlue),
    }), [darkModeButton, selectedTheme]);

    return (
        <DarkModeContext.Provider value={contextValue}>
            <ThemeProvider theme={selectedTheme}>
                <GlobalStyle/>
                {children}
            </ThemeProvider>
        </DarkModeContext.Provider>
    )

}